import Vue from "vue";
// import AV from "leancloud-storage";
import store from "@/store/index";
import { Toast } from "vant";
// import {
//   Realtime,
//   TextMessage,
//   TypedMessage,
//   messageType,
//   messageField
// } from "leancloud-realtime";
// import { ImageMessage } from "leancloud-realtime-plugin-typed-messages";
const {
  Realtime,
  TextMessage,
  TypedMessagesPlugin,
  ImageMessage,
} = AV;

var chatConfig = {
  IMclient: null,
  IMclientConver: null,
  messageIterator: null
};
var leancloudInfo = {
  appId: "BL0eDKFkzB8qmoWMYFxdCWFf-gzGzoHsz",
  appKey: "Y2zyu6d0rUsxWNSaQKJDqQTk",
  serverURLs: "https://leancloud.youinsh.com"
};
var realtime;
var limit = 1000; //表示保留多少条聊天消息
var count = 20; //表示聊天记录 每次显示多少条 

var page_this;
var ImInstantiation;
var newHistory = [];
function init(it) {
  AV.init(leancloudInfo);
  page_this = it;
}
function exitRoom() {
  chatConfig.IMclientConver.quit().then(res => {
    console.log('退出成功', res.members);
    joinRoom(page_this.userInfo)
  }).catch(console.error.bind(console))
    page_this.isShowNickname = false
}
function joinRoom(user) {
  // console.log(user)
  // 加入房间
  let userId = user.id;
  let userName =
    user.nickname.length > 20
      ? user.nickname.substr(0, 16)
      : user.nickname;
    chatConfig.IMclient = realtime
    .createIMClient(
      JSON.stringify({
        userId,
        userName
      })
    )
    .then(function name(client) {
      chatConfig.IMclient = client;
      return client.getConversation(page_this.courseInfo.chat_room_id);
    })
    .then(function (conversation) {
      // console.log("加入成功")
      messageMonitorOn()  ////订阅监听实时消息事件
      return conversation.join();
    })
    .then(function (conversation) {
      chatConfig.IMclientConver = conversation;
      ImInstantiation = chatConfig;
      chatConfig.IMclient.getQuery()
        .containsMembers([chatConfig.IMclient.id])
        .find()
        .then(function (conversation) {
          conversation.forEach(conversation => {
            if (chatConfig.IMclientConver.id != conversation.id) {
              conversation
                .quit()
                .then(function (conversation) { })
                .catch(() => {
                  console.error.bind(console);
                });
            }
          });
        })
        .catch(() => {
          // slef.initResults(false);
        });
    })
    .catch((e) => {
      console.error(e)
      // slef.initResults(false);
    });
}
function messageMonitorOn(){   ////订阅监听实时消息事件
    // console.log("监听",chatConfig.IMclient)
    chatConfig.IMclient.on("message", function (message, conversation) {
      // console.log("订阅消息watch", message)

      // 处理带有引用消息的订阅消息
      if (isJSON(message._lctext)) {
        var contentObj = JSON.parse(message._lctext);
        if (contentObj.type == "referenceInfo") {
          referenceMessagesProcessing(message, "订阅");
        } else {
          messageProcessing(message, "订阅");
        }
      } else {
        messageProcessing(message, "订阅");
      }
      if (message._lctext == '$youin&atomy&livestop$') {
        page_this.livePlayerStatus = 0
        if (page_this.videoPlayer) {
          // console.log(page_this.videoPlayer)
          page_this.disposePlayer('play-con');
        }
      }
      if (message.content._lcattrs.ws_type == 'notify_stop_live1') {
        setTimeout(() => {
          let content;
          if (moment(page_this.courseInfo.end_time).valueOf() - page_this.nowDate < 0) {
            page_this.livePlayerStatus = 0
            // $('.playerStatus').html("直播已结束");
          }
          if (page_this.isMobile()) {
            content = 'play-con';
            if (moment(page_this.courseInfo.end_time).valueOf() - page_this.nowDate < 0) {
              $('#playmask').show();
            }
          } else {
            content = 'play-con-pc';
            if (moment(page_this.courseInfo.end_time).valueOf() - page_this.nowDate < 0) {
              $('#playerMask').show();
            }
          }
          if (page_this.videoPlayer) {
            console.log(page_this.videoPlayer)
            page_this.disposePlayer(content);
          }
        }, 8000)
      }
    }); // 加入成功 ['Bob', 'Harry', 'William', 'Tom']
}
function initLeancloud(chatRoomId, user, source = false) {
  console.log(user)
  realtime = new Realtime({
    appId: leancloudInfo.appId,
    appKey: leancloudInfo.appKey,
    region: "cn",
    server: leancloudInfo.serverURLs
  });
  let userId = user.id;
  let userName =
    user.nickname.length > 20
      ? user.nickname.substr(0, 16)
      : user.nickname;
  chatConfig.IMclient = realtime
    .createIMClient(
      JSON.stringify({
        userId,
        userName
      })
    )
    .then(function (client) {
      chatConfig.IMclient = client;
      return client.getConversation(chatRoomId);
    })
    .then(function (conversation) {
      return conversation.join();
    })
    .then(function (conversation) {
      chatConfig.IMclientConver = conversation;
      ImInstantiation = chatConfig;
      if (!chatConfig.messageIterator) {
        chatConfig.messageIterator = chatConfig.IMclientConver.createMessagesIterator(
          {
            limit: limit
          }
        );
      }
      const history = chatConfig.messageIterator.next();
      history
        .then(val => {
          // console.log(val, "val");
          let historyMessage = val.value;
          historyMessage.forEach(item => {
            item.uid = item.id
            if (isJSON(item._lctext)) {
              var contentObj = JSON.parse(item._lctext);
              if (contentObj.type == "referenceInfo") {
                referenceMessagesProcessing(item, "历史");
              } else {
                messageProcessing(item, "历史");
              }
            } else {
              messageProcessing(item, "历史");
            }
          });
          console.log(historyMessage, '历史消息')

					// let topicArray = historyMessage.filter(function (ele) {
					// 	return isJSON(ele._lctext) && isJSON(ele._lctext).type == 'sorrow'
					// })
					// let publishingRankingS = historyMessage.filter(function (item) {
					// 	return isJSON(item._lctext) && isJSON(item._lctext).type == 'publishingRanking'
					// })
					// if (publishingRankingS.length > 0) {
					// 	// $('.dt_phb_box').show()
            
					// 	var totalRankList = isJSON(publishingRankingS[0]._lctext).topicList
          //   console.log(totalRankList)
					// }
					// if (topicArray.length > 0) {
					// 	if (isJSON(topicArray.slice(-1)[0]._lctext).topicInfo.status == 2 ) {
					// 		// $('.answer_box_list').show()
					// 		// $('.answer_box_correct').hide()
					// 		// $('.answer_box_error').hide()
					// 		// $('.answer_box_single').hide()
          //     console.log(isJSON(topicArray.slice(-1)[0]._lctext).topicInfo)
					// 		// renderingFn(isJSON(topicArray.slice(-1)[0]._lctext).topicInfo)
          //     page_this.renderingFn(isJSON(topicArray.slice(-1)[0]._lctext).topicInfo)
					// 	}
					// }
          var html = "";
          setTimeout(() => {
            if (!source) {
              page_this.historyChatHandFn(historyList, count);
              page_this.loadingChatStatus = false;
            }
          }, 1000);
        })
        .catch();
        messageMonitorOn() //订阅监听实时消息事件
      chatConfig.IMclient.getQuery()
        .containsMembers([chatConfig.IMclient.id])
        .find()
        .then(function (conversations) {
          conversations.forEach(conversation => {
            if (chatConfig.IMclientConver.id != conversation.id) {
              conversation
                .quit()
                .then(function (conversation) { })
                .catch(console.error.bind(console));
            }
          });
        })
        .catch(console.error.bind(console));
    })
    .catch(console.error.bind(console));
  return chatConfig.IMclient;
}
// 发送信息
function putImgFn(val, is_forbidden) {
  if (!is_forbidden) {
    sendImgMsg(val)
      .then(data => {
        messageProcessing(data, "发送");
        val = "";
      })
      .catch(e => {
        console.log(e);
      });
  } else {
    Toast("你已被禁言！");
  }
}

/**
 * 获取历史记录的上一页
 * @param {*} sourceTime 上次获取的第一条消息时间戳
 * @param {*} messageId 上次获取的第一条消息id
 */
function getImHistoryChat(sourceTime, messageId) {
  newHistory = []
  time = sourceTime;
  // ImInstantiation 声明的全局im实例
  if (!ImInstantiation.messageIterator) {
    ImInstantiation.messageIterator = ImInstantiation.IMclientConver.createMessagesIterator(
      {
        limit: limit,
        beforeMessageId: messageId,
        beforeTime: sourceTime
      }
    );
  }
  const history = ImInstantiation.messageIterator.next();
  history
    .then(val => {
      // console.log(val, "刷新请求数据val");
      let historyMessage = val.value;
      historyMessage.forEach(item => {
        if (isJSON(item._lctext)) {
          var contentObj = JSON.parse(item._lctext);
          if (contentObj.type == "referenceInfo") {
            referenceMessagesProcessing(item, "历史");
          } else {
            messageProcessing(item, "历史");
          }
        } else {
          messageProcessing(item, "历史");
        }
      });
      
      var html = "";
      setTimeout(() => {
        historyList = newHistory.concat(historyList)
        page_this.historyChatHandFn(historyList, count, sourceTime);
        // page_this.loadingChatStatus = false;
      }, 1000);
    })
    .catch(error => {
      console.log(error);
    });
}

function sendImgMsg(file) {
  // 发送图片消息
  var avFile = new AV.File("avatar.jpg", file);
  return avFile.save().then(() => {
    var message = new ImageMessage(avFile);
    message.setAttributes(get_getMsgAttr());
    return chatConfig.IMclientConver.send(message);
  });
}
function messageProcessing(item, type) {
  // console.log("消息处理", item, type);
  // 消息处理
  try {
    var obj = {};
    if (isJSON(item.from)) {
      obj.userId = JSON.parse(item.from).userId;
      obj.userName = JSON.parse(item.from).userName;
    } else {
      // 非历史消息
      if (type != "历史") {
        if (item.from == "publish_callback" || item.from == "static_callback") {
          // 开始推流
          if (item.content._lcattrs.ws_type == "notify_start_live") {
            setTimeout(() => {
              if (!page_this.videoPlayer) {
                clearInterval(page_this.recordTimer);
                page_this.livePlayerStatus = 2
                if(page_this.videoOption){
                  page_this.newPlayer(page_this.videoOption, 'play-con');
                }
                console.log(page_this.videoPlayer);
              }
            }, 10000)
            return;
          }
          // 结束推流
          if (item.content._lcattrs.ws_type == "notify_stop_live") {
            page_this.livePlayerStatus = 0
            console.log("结束推流了")
            return;
          }
        }
        if (item._lcattrs.ws_type == "end_live") {
          page_this.livePlayerStatus = 0
          console.log("结束推流了")
          return;
          //   store.dispatch("Live/setActionsLiveStatus", true);
        }
      }
    }

    obj.timer = item._timestamp;
    obj.id = item.id;
    obj.attribute = type;
    try {
      item._lctext = item._lctext
        ? item.content._lctext
        : item.content._lcattrs;
    } catch (e) {
      item._lctext = item._lctext;
    }
    if (item._lctext) {
      if (isJSON(item._lctext)) {
        var msgObj = JSON.parse(item._lctext);
        msgObj.attribute = type;
        if (type == "订阅") {
          signaling_message_processing(msgObj);
        }
        if (type == '历史') {
          histeryMsg(msgObj)
        }
        if (msgObj.type == "gift") {
          msgObj.id = msgObj.userId;
          if (type == "礼物") {
            page_this.showSendGift(msgObj);
          }
          onMessage(msgObj);
        }
        return;
      }

    }
    try {
      obj.avatar = item._lcattrs.avatar;
    } catch (e) {
      try {
        if (obj.avatar == undefined) {
          obj.avatar = item.content._lcattrs.avatar;
        }
      } catch (e) {
        obj.avatar =
          "https://stagingcdn.youinsh.cn/staging/static/user/images/default_user.png";
      }
    }
    if (item._lcfile) {
      try {
        obj.content = "//" + item._lcfile.split("://")[1];
        obj.type = "img";
      } catch (e) {
        obj.content = "//" + item._lcfile.url.split("://")[1];
        obj.type = "img";
      }
    } else {
      if (item._lctext == undefined) {
        obj.type = "prompt";
        obj.content = obj.userName + " 撤回了一条消息";
        onMessage(obj);
        return;
      }
    }
    try {
      if (item.content._lcfile) {
        obj.content = "//" + item.content._lcfile.url.split("://")[1];
        obj.type = "img";
      } else if (item._lctext) {
        obj.content = item._lctext.replace("<br>", "");
        obj.type = "text";
      }
    } catch (e) {
      try {
        if (item._lctext) {
          obj.content = item._lctext.replace("<br>", "");
          obj.type = "text";
        }
      } catch (e) {
        if (item.content._lctext.indexOf("<img") != -1) {
          obj.content = item.content._lctext;
          obj.type = "gift";
        }
      }
    }
    try {
      if (item.id) {
        obj.uid = item.id;
      } else if (item._lctext) {
        obj.uid = item.id;
      }
    } catch (e) {
      try {
        if (item.id) {
          obj.uid = item.id;
        } else if (item._lctext) {
          obj.uid = item.id;
        }
      } catch (e) {
        if (item.id) {
          obj.uid = item.id;
        } else if (item._lctext) {
          obj.uid = item.id;
        }
      }
    }
    onMessage(obj);
  } catch (e) { }
}
function histeryMsg(obj, type) {  //处理历史消息
  // console.log(obj,type)
  if (obj.type == "publishingRanking") {
    page_this.isShowAnswerIcon = true
    page_this.totalRankList = obj.topicList
  }
}
// 处理引用消息
function referenceMessagesProcessing(item, type) {
  console.log("处理引用消息", item, type);
  try {
    var obj = {};
    obj.userId = JSON.parse(item.from).userId;
    obj.userName = JSON.parse(item.from).userName;
    obj.timer = item._timestamp;
    obj.id = item.id;
    obj.attribute = type;
    obj.avatar = item._lcattrs.avatar;
    if (isJSON(item._lctext)) {
      var contentObj = JSON.parse(item._lctext);
      if (contentObj.msg) {
        obj.content = contentObj.msg;
        obj.type = "text";
      }
      if (contentObj.url) {
        let web = new URL(contentObj.url);
        obj.content = contentObj.url.substr(
          contentObj.url.indexOf(web.protocol) + web.protocol.length,
          contentObj.url.length
        );
        obj.type = "img";
      }
      obj.referenceInfo = contentObj.referenceInfo;
    }
    onMessage(obj);
  } catch (e) { }
}

// 处理信息操作信息
function signaling_message_processing(obj) {
  // console.log(obj, '---消息处理--')
  // 禁言
  switch (obj.type) {
    case "forbidden":
      if (obj.userId == page_this.userInfo.id) {
        page_this.isMgsDisable = obj.status
        // page_this.courseJsonDate.isProhibit = obj.status
        Toast({
          message: obj.status ? "你已被禁言" : "你已被解除禁言",
          position: "top"
        });
      }
      break;
    case "forbidden_all":
        page_this.isMgsDisable = obj.status
        // page_this.courseJsonDate.isProhibit = obj.status
        Toast({
            message: obj.status ? "管理员已开启全体禁言" : "管理员已解除全体禁言",
            position: "top"
        });
        break;
    case "kick": //踢出直播间
      if (page_this.userInfo.id == obj.userId) {
        // page_this.isBlackNameList = obj.status
        if(obj.status){
          window.location.href = 'https://atomy.youinsh.cn/blacklist/'
        }
        // page_this.livePlayerStatus = 0
      }
      break;
    case 'sorrow': //答题
      if (obj.topicInfo.status == '2') {
        // console.log("答题----",obj)
        let sorrow_id = localStorage.getItem('sorrow_id');
        if(sorrow_id==obj.topicInfo.id){
          return
        }
        localStorage.setItem('sorrow_id',obj.topicInfo.id);
        // console.log(obj)
        page_this.renderingFn(obj.topicInfo)
      } else {
        if (page_this.answerPageType == 1 || page_this.answerPageType == null) {
          page_this.isShowAnswer = false
        }
        // page_this.isShowAnswer = false
      }
      break;
    case 'publishingRanking':  //发布答题榜
      page_this.isShowAnswerIcon = true
      page_this.totalRankList = obj.topicList
      page_this.isShowAnswer = true
      page_this.isShowAnswerRankingList = true
      break;
  }
}

// 发送信息
function putTextFn(newsInfo, is_forbidden) {
  if (!is_forbidden) {
    sendMsg(newsInfo)
      .then(data => {
        if (isJSON(data._lctext)) {
          var contentObj = JSON.parse(data._lctext);
          if (contentObj.type == "referenceInfo") {
            referenceMessagesProcessing(data, "发送");
          }
        } else {
          messageProcessing(data, "发送");
        }

        newsInfo = "";
      })
      .catch(e => {
        console.log(e);
      });
  } else {
    Toast("你已被禁言！");
  }
}
// 发送文本消息
function sendMsg(text, type) {
  //   console.log("处理消息", text, type)
  if (!isNaN(text * 1)) {
    text = text + "<br>";
  }
  // 发送文本聊天消息
  let message = new TextMessage(text);
  message.setAttributes(get_getMsgAttr(text));
  return chatConfig.IMclientConver.send(message);
}
// 获取头像
function get_getMsgAttr() {
  return {
    avatar: page_this.userInfo.headImageUrl // +'?isAdmin='+result
  };
}
var historyList = [];
function onMessage(msg) {
  if (msg.attribute != "历史") {
    page_this.reamtimeChatHandFn(msg);
  } else {
    historyList.push(msg);
  }
}

function isJSON(str) {
  if (typeof str == "string") {
    try {
      if (typeof JSON.parse(str) == "object") {
        return JSON.parse(str);
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}
//审核消息push自己消息 页面可看到
function auditmessagemain(item) {
  // console.log(item)
  let data = {
    type: item.type, //类型  text 或 img
    avatar: item.avatar, //头像
    userName: item.userName, //用户名字
    timer: Date.parse(new Date()), //时间戳
    content: item.content,
    giftName: item.giftName,
    giftCount: item.giftCount,
    userId: item.userId,
    referenceInfo: item.referenceInfo,
    id: Date.parse(new Date())
  };
  page_this.reamtimeChatHandFn(data);
}

//审核消息时图片处理
function audiImg(file) {
  var avFile = new AV.File("avatar.jpg", file);
  var message = null;
  return avFile.save().then(() => {
    message = new ImageMessage(avFile);
    return message;
  });
}

export default {
  init,
  initLeancloud,
  signaling_message_processing,
  messageProcessing,
  putTextFn,
  sendMsg,
  sendImgMsg,
  putImgFn,
  auditmessagemain,
  audiImg,
  getImHistoryChat,
  exitRoom
};



// WEBPACK FOOTER //
// ./src/assets/js/chatWatch.js